import {
  EventStatisticField,
  GlobalStatisticsCategories,
  GlobalStatisticTrendPeriod,
  LeadStatisticField,
  MembershipStatisticField,
  RevenueStatisticField,
  VisitStatisticField,
} from "@gymflow/types";
import { AxiosInstance } from "axios";

export type StatisticsApiType = ReturnType<typeof statisticsApi>;

const statisticsApi = (axiosInstance: AxiosInstance, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;

  return {
    getData(
      clubId: number,
      start: string,
      end: string,
      trendPeriod: GlobalStatisticTrendPeriod = "MONTH",
      categories: GlobalStatisticsCategories[] = [
        "revenue",
        "membership",
        "event",
        "lead",
        "visit",
      ],
      revenueFields?: RevenueStatisticField[],
      membershipFields?: MembershipStatisticField[],
      eventFields?: EventStatisticField[],
      leadFields?: LeadStatisticField[],
      visitFields?: VisitStatisticField[],
      membershipIncluded?: number[],
      membershipExcluded?: number[],
    ) {
      const body = {} as any;

      if (categories.includes(STATISTICS_CATEGORY.Revenue)) {
        body.revenue = {
          filter: {
            fields: revenueFields,
            initialDate: start,
            finalDate: end,
            trendPeriod,
          },
        };
      }

      if (categories.includes(STATISTICS_CATEGORY.Membership)) {
        body.membership = {
          filter: {
            fields: membershipFields,
            initialDate: start,
            finalDate: end,
            trendPeriod,
            membershipIncluded,
            membershipExcluded,
          },
        };
      }

      if (categories.includes(STATISTICS_CATEGORY.Event)) {
        body.event = {
          filter: {
            fields: eventFields,
            initialDate: start,
            finalDate: end,
            trendPeriod,
          },
        };
      }

      if (categories.includes(STATISTICS_CATEGORY.Lead)) {
        body.lead = {
          filter: {
            fields: leadFields,
            initialDate: start,
            finalDate: end,
            trendPeriod,
          },
        };
      }

      if (categories.includes(STATISTICS_CATEGORY.Visit)) {
        body.visit = {
          filter: {
            fields: visitFields,
            initialDate: start,
            finalDate: end,
            trendPeriod,
          },
        };
      }

      return axiosInstance.post(`${clubPrefix}statistic`, body);
    },
  };
};

export const STATISTICS_CATEGORY = {
  Revenue: "revenue",
  Membership: "membership",
  Event: "event",
  Lead: "lead",
  Visit: "visit",
} as const;

export const REVENUE_FIELD = {
  Total: "total",
  Membership: "membership",
  CreditPack: "sessionPack",
  Product: "product",
} as const;

export const MEMBERSHIP_FIELD = {
  Active: "active",
  Paused: "paused",
  Cancelled: "cancelled",
  SignUps: "signUps",
  Overdue: "overdue",
} as const;

export const EVENT_FIELD = {
  Attendance: "attendance",
  BookingPercentage: "bookingPercentage",
} as const;

export default statisticsApi;
